import type { CampaignOffer, CampaignSection } from "@/lib/api";

const WIB_DAY = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta" });

/** Today as a WIB calendar day, YYYY-MM-DD. */
export function todayWIB(now = new Date()): string {
  return WIB_DAY.format(now);
}

/** Whether an offer is still running: no end date, or the end day not yet past (WIB). */
export function offerLive(offer: Pick<CampaignOffer, "endsOn">, now = new Date()): boolean {
  return !offer.endsOn || offer.endsOn >= todayWIB(now);
}

/** "31 Oktober 2026", for "Berlaku sampai …". */
export function formatDay(day: string): string {
  const [y, m, d] = day.split("-").map(Number);
  if (!y || !m || !d) return day;
  return new Intl.DateTimeFormat("id-ID", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }).format(
    new Date(Date.UTC(y, m - 1, d)),
  );
}

/**
 * The anchor for each products section, the whole range included: "produk",
 * then "produk-2", … so a hero button can point at "#produk" without anyone
 * knowing the layout.
 */
export function productAnchors(sections: CampaignSection[]): Map<number, string> {
  const out = new Map<number, string>();
  let n = 0;
  sections.forEach((s, i) => {
    if (s.type !== "products" && s.type !== "range") return;
    n += 1;
    out.set(i, n === 1 ? "produk" : `produk-${n}`);
  });
  return out;
}
